import { Instance } from 'mobx-state-tree';
import { ProjectCreatedDtoModelBase } from './ProjectCreatedDtoModel.base';

/* The TypeScript type of an instance of ProjectCreatedDtoModel */
export interface ProjectCreatedDtoModelType extends Instance<typeof ProjectCreatedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectCreatedDtoModel */
export { selectFromProjectCreatedDto, projectCreatedDtoModelPrimitives, ProjectCreatedDtoModelSelector } from './ProjectCreatedDtoModel.base';

/**
 * ProjectCreatedDtoModel
 *
 * Created project
 */
export const ProjectCreatedDtoModel = ProjectCreatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
